<template>
  <MainLayout>
    <div 
      :class="theme === 'dark' ? 'tw-bg-[#151515] tw-text-gray-100' : 'tw-bg-gray-100 tw-text-gray-800'" 
      class="tw-min-h-screen tw-p-4 md:tw-p-8"
      :data-theme="theme"
    >
      <div class="tw-mb-6 md:tw-mb-8">
        <h1 :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-800'" class="tw-text-xl md:tw-text-2xl tw-font-bold">
          Relatório de Aeração - {{ unidade.nome || 'Unidade' }}
        </h1>
      </div>

      <div class="tw-grid tw-grid-cols-1 tw-gap-6 md:tw-gap-8">
        <div 
          :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" 
          class="tw-rounded-2xl tw-p-5 md:tw-p-8 tw-shadow-2xl"
        >
          <div class="tw-flex tw-items-center tw-gap-4 tw-mb-6 md:tw-mb-8">
            <div :class="theme === 'dark' ? 'tw-bg-blue-500/10' : 'tw-bg-blue-50'" class="tw-p-3 tw-rounded-xl">
              <i class="fa-solid fa-filter tw-text-blue-500 tw-text-lg"></i>
            </div>
            <h2 :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-800'" class="tw-text-base md:tw-text-lg tw-font-bold">
              Filtros de Busca
            </h2>
          </div>

          <form @submit.prevent="gerarRelatorio(1)">
            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-5 tw-gap-4 md:tw-gap-6">
              <div class="tw-space-y-2">
                <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Silo / Armazém</label>
                <BaseSelect v-model="selectedSilo" :options="silosFiltered" option-label="nome" option-value="id" placeholder="Selecione o local" searchable />
              </div>

              <div class="tw-space-y-2">
                <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Período</label>
                <BaseSelect v-model="data_pre_definida" :options="periodoOptions" option-label="label" option-value="value" />
              </div>

              <div v-if="data_pre_definida === PERIODO_MANUAL" class="tw-space-y-2">
                <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Início</label>
                <input type="date" v-model="dataInicio" class="tw-custom-input tw-border-none" />
              </div>

              <div v-if="data_pre_definida === PERIODO_MANUAL" class="tw-space-y-2">
                <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Término</label>
                <input type="date" v-model="dataFinal" class="tw-custom-input tw-border-none" />
              </div>

              <div class="tw-space-y-2">
                <label class="tw-block tw-text-[10px] tw-font-bold tw-text-gray-400 tw-uppercase">Por Página</label>
                <BaseSelect v-model="per_page" :options="perPageOptions">
                  <template #option="{ option }">{{ option }} Itens</template>
                  <template #value="{ selected }">{{ selected }} Itens</template>
                </BaseSelect>
              </div>
            </div>

            <div class="tw-mt-8 tw-flex tw-justify-end tw-gap-4">
              <button 
                type="submit" 
                :disabled="loadingDados"
                class="tw-px-8 tw-py-3 tw-rounded-xl tw-bg-green-600 tw-text-white tw-text-sm tw-font-bold hover:tw-bg-green-700 tw-shadow-lg tw-shadow-green-600/20 tw-border-none disabled:tw-opacity-50"
              >
                <span v-if="!loadingDados">Visualizar Aeração</span>
                <span v-else class="tw-flex tw-items-center tw-gap-2">
                    <svg class="tw-animate-spin tw-h-4 tw-w-4 tw-text-white" fill="none" viewBox="0 0 24 24"><circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                    Carregando...
                </span>
              </button>
            </div>
          </form>
        </div>

        <div 
          :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" 
          class="tw-rounded-2xl tw-p-0 tw-shadow-2xl tw-overflow-hidden tw-relative tw-min-h-[300px]"
        >
          <div>
            <div v-if="loadingDados" class="tw-absolute tw-inset-0 tw-z-10 tw-bg-inherit tw-flex tw-flex-col tw-items-center tw-justify-center">
                <svg class="tw-animate-spin tw-h-10 tw-w-10 tw-text-green-500" fill="none" viewBox="0 0 24 24"><circle class="tw-opacity-20" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="tw-opacity-100" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                <span class="tw-mt-4 tw-text-xs tw-font-bold tw-uppercase tw-tracking-widest tw-opacity-50">Sincronizando dados de acionamento...</span>
            </div>
          </div>

          <div class="tw-p-5 tw-p-8 tw-border-b tw-border-gray-800/10 tw-flex tw-justify-between tw-items-center">
            <div class="tw-flex tw-items-center tw-gap-4">
              <div :class="theme === 'dark' ? 'tw-bg-green-500/10' : 'tw-bg-green-50'" class="tw-p-3 tw-rounded-xl">
                <i class="fa-solid fa-file-invoice tw-text-green-500 tw-text-lg"></i>
              </div>
              <div>
                <h2 :class="theme === 'dark' ? 'tw-text-gray-100' : 'tw-text-gray-800'" class="tw-text-base tw-text-lg tw-font-bold">Relatório da Aeração</h2>
                <p v-if="selectedSiloNome" class="tw-text-[10px] tw-font-bold tw-text-gray-500 tw-uppercase">{{ selectedSiloNome }}</p>
              </div>
            </div>
          </div>

          <div v-if="aeracaoData && aeracaoData.length > 0" :class="{'tw-opacity-20': loadingDados}" class="tw-hidden md:tw-block tw-overflow-x-auto">
            <table class="tw-w-full tw-text-left tw-border-none">
              <thead>
                <tr :class="theme === 'dark' ? 'tw-bg-black/20' : 'tw-bg-gray-50/50'">
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Data/Hora</th>
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Motores</th>
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Modo</th>
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Produto</th>
                  <th class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-[11px] md:tw-text-xs tw-font-bold tw-text-gray-400 tw-uppercase tw-tracking-wider">Estação</th>
                </tr>
              </thead>
              <tbody class="tw-divide-y tw-divide-gray-800/10">
                <tr v-for="(item, index) in aeracaoData" :key="index" class="hover:tw-bg-black/5">
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-whitespace-nowrap">
                    <span :class="theme === 'dark' ? 'tw-text-gray-200' : 'tw-text-gray-800'" class="tw-text-sm tw-font-semibold">{{ dataParte(item.aeracao.data) }}</span>
                    <span class="tw-text-sm tw-text-gray-500 tw-ml-2 tw-tabular-nums">{{ horaParte(item.aeracao.data) }}</span>
                  </td>
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4">
                    <div class="tw-flex tw-flex-wrap tw-gap-2">
                      <div
                        v-for="motor in item.motores" :key="motor.descricao"
                        :class="motor.status == 1
                          ? (theme === 'dark' ? 'tw-bg-green-500/15 tw-text-green-400 tw-border-green-500/30' : 'tw-bg-green-50 tw-text-green-700 tw-border-green-200')
                          : (theme === 'dark' ? 'tw-bg-white/5 tw-text-gray-400 tw-border-white/10' : 'tw-bg-gray-100 tw-text-gray-500 tw-border-gray-200')"
                        class="tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1.5 tw-rounded-lg tw-border"
                      >
                        <i :class="motor.status == 1 ? 'fa-solid fa-fan fa-spin' : 'fa-solid fa-fan tw-opacity-50'" class="tw-text-sm"></i>
                        <span class="tw-text-sm tw-font-semibold">{{ motor.descricao }}</span>
                        <span class="tw-text-[11px] tw-font-bold tw-uppercase">{{ motor.status == 1 ? 'Ligado' : 'Desligado' }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-sm tw-font-semibold">{{ item.aeracao.modo_operacao == 1 ? 'Automático' : 'Manual' }}</td>
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4 tw-text-sm">{{ getProdutoNome(item.aeracao.produto) }}</td>
                  <td class="xs:tw-px-1 md:tw-px-6 tw-py-4">
                    <div v-if="item.estacao.temperatura != null" class="tw-flex tw-items-center tw-gap-4 tw-text-sm tw-whitespace-nowrap">
                      <span class="tw-flex tw-items-center tw-gap-1.5" title="Temperatura">
                        <i class="fa-solid fa-temperature-half tw-text-orange-500"></i>
                        <span class="tw-font-semibold tw-tabular-nums">{{ item.estacao.temperatura }}°C</span>
                      </span>
                      <span class="tw-flex tw-items-center tw-gap-1.5" title="Umidade relativa">
                        <i class="fa-solid fa-droplet tw-text-sky-500"></i>
                        <span class="tw-font-semibold tw-tabular-nums">{{ item.estacao.umidade }}%</span>
                      </span>
                      <span class="tw-flex tw-items-center tw-gap-1.5" :title="item.estacao.chuva == 1 ? 'Chovendo' : 'Sem chuva'">
                        <i :class="item.estacao.chuva == 1 ? 'fa-solid fa-cloud-showers-heavy tw-text-blue-500' : 'fa-solid fa-cloud tw-text-gray-400 tw-opacity-60'"></i>
                        <span :class="item.estacao.chuva == 1 ? 'tw-text-blue-500 tw-font-semibold' : 'tw-text-gray-400'" class="tw-text-xs">{{ item.estacao.chuva == 1 ? 'Chuva' : 'Sem chuva' }}</span>
                      </span>
                    </div>
                    <span v-else class="tw-text-xs tw-font-bold tw-text-red-500">OFF</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="aeracaoData && aeracaoData.length > 0" :class="{'tw-opacity-20': loadingDados}" class="md:tw-hidden tw-divide-y tw-divide-gray-800/10">
            <div v-for="(item, index) in aeracaoData" :key="'mob-'+index" class="tw-p-5 tw-space-y-3">
              <div class="tw-flex tw-justify-between tw-items-start tw-gap-3">
                <div>
                  <span :class="theme === 'dark' ? 'tw-text-gray-200' : 'tw-text-gray-800'" class="tw-text-sm tw-font-semibold">{{ dataParte(item.aeracao.data) }}</span>
                  <span class="tw-text-sm tw-text-gray-500 tw-ml-1.5 tw-tabular-nums">{{ horaParte(item.aeracao.data) }}</span>
                </div>
                <div class="tw-text-right tw-shrink-0">
                  <span class="tw-block tw-text-xs tw-font-bold tw-uppercase">{{ item.aeracao.modo_operacao == 1 ? 'Automático' : 'Manual' }}</span>
                  <span class="tw-block tw-text-xs tw-text-gray-400">{{ getProdutoNome(item.aeracao.produto) }}</span>
                </div>
              </div>
              <div class="tw-flex tw-flex-wrap tw-gap-2">
                <div
                  v-for="motor in item.motores" :key="motor.descricao"
                  :class="motor.status == 1
                    ? (theme === 'dark' ? 'tw-bg-green-500/15 tw-text-green-400 tw-border-green-500/30' : 'tw-bg-green-50 tw-text-green-700 tw-border-green-200')
                    : (theme === 'dark' ? 'tw-bg-white/5 tw-text-gray-400 tw-border-white/10' : 'tw-bg-gray-100 tw-text-gray-500 tw-border-gray-200')"
                  class="tw-flex tw-items-center tw-gap-1.5 tw-px-2.5 tw-py-1 tw-rounded-lg tw-border"
                >
                  <i :class="motor.status == 1 ? 'fa-solid fa-fan fa-spin' : 'fa-solid fa-fan tw-opacity-50'" class="tw-text-xs"></i>
                  <span class="tw-text-xs tw-font-semibold">{{ motor.descricao }}</span>
                  <span class="tw-text-[10px] tw-font-bold tw-uppercase">{{ motor.status == 1 ? 'Ligado' : 'Desligado' }}</span>
                </div>
              </div>
              <div v-if="item.estacao.temperatura != null" class="tw-flex tw-flex-wrap tw-items-center tw-gap-4 tw-text-sm">
                <span class="tw-flex tw-items-center tw-gap-1.5"><i class="fa-solid fa-temperature-half tw-text-orange-500"></i><span class="tw-font-semibold">{{ item.estacao.temperatura }}°C</span></span>
                <span class="tw-flex tw-items-center tw-gap-1.5"><i class="fa-solid fa-droplet tw-text-sky-500"></i><span class="tw-font-semibold">{{ item.estacao.umidade }}%</span></span>
                <span class="tw-flex tw-items-center tw-gap-1.5">
                  <i :class="item.estacao.chuva == 1 ? 'fa-solid fa-cloud-showers-heavy tw-text-blue-500' : 'fa-solid fa-cloud tw-text-gray-400 tw-opacity-60'"></i>
                  <span :class="item.estacao.chuva == 1 ? 'tw-text-blue-500 tw-font-semibold' : 'tw-text-gray-400'" class="tw-text-xs">{{ item.estacao.chuva == 1 ? 'Chuva' : 'Sem chuva' }}</span>
                </span>
              </div>
              <span v-else class="tw-text-xs tw-text-red-500 tw-font-bold">Estação OFF</span>
            </div>
          </div>

          <div v-if="!loadingDados && aeracaoData && aeracaoData.length > 0" class="tw-px-6 tw-py-6 tw-bg-black/5 tw-border-t tw-border-gray-800/10">
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-between tw-gap-4">
              <div class="tw-text-xs tw-font-medium tw-opacity-60">
                Mostrando <span class="tw-font-bold">{{ (pagination.current_page - 1) * per_page + 1 }}</span> a 
                <span class="tw-font-bold">{{ Math.min(pagination.current_page * per_page, pagination.total) }}</span> de 
                <span class="tw-font-bold">{{ pagination.total }}</span> acionamentos
              </div>

              <nav v-if="pagination.last_page > 1" class="tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-1">
                <button @click="gerarRelatorio(pagination.current_page - 1)" :disabled="pagination.current_page === 1" class="tw-w-9 tw-h-9 tw-flex tw-items-center tw-justify-center tw-rounded-lg hover:tw-bg-black/10 disabled:tw-opacity-10 tw-border-none tw-bg-transparent tw-text-inherit"><i class="fa-solid fa-chevron-left tw-text-[10px]"></i></button>
                <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-1">
                  <button v-for="link in filteredPaginationLinks" :key="link.label" @click="handlePaginationClick(link)" :class="['tw-w-9 tw-h-9 tw-text-xs tw-font-bold tw-rounded-lg tw-border-none', link.active ? 'tw-bg-green-600 tw-text-white tw-shadow-md tw-shadow-green-600/20' : 'tw-bg-transparent hover:tw-bg-black/10 tw-opacity-60']" v-html="link.label"></button>
                </div>
                <button @click="gerarRelatorio(pagination.current_page + 1)" :disabled="pagination.current_page === pagination.last_page" class="tw-w-9 tw-h-9 tw-flex tw-items-center tw-justify-center tw-rounded-lg hover:tw-bg-black/10 disabled:tw-opacity-10 tw-border-none tw-bg-transparent tw-text-inherit"><i class="fa-solid fa-chevron-right tw-text-[10px]"></i></button>
              </nav>
            </div>
          </div>

          <div v-else-if="!loadingDados && (!aeracaoData || aeracaoData.length === 0)" class="tw-py-16 tw-text-center">
            <p class="tw-text-gray-500 tw-text-xs tw-font-medium tw-uppercase tw-tracking-widest tw-opacity-50">Nenhum registro encontrado para este período.</p>
          </div>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
/* eslint-disable */
import MainLayout from "@/components/layouts/v2/MainLayout.vue";
import LoadingRelatorio from "@/components/ui/App/LoadingRelatorio.vue";
import { useToast } from "vue-toastification";
import { mapState } from 'vuex';
import BaseSelect from "@/components/ui/v2/BaseSelect.vue";
import { PERIODO_MANUAL, PERIODO_OPTIONS, getDatasPeriodo, hojeLocal } from "@/utils/periodoRelatorio";

export default {
    name: 'RelatorioAeracao',
    components: { MainLayout, LoadingRelatorio, BaseSelect },
    data() {
        const today = hojeLocal();
        return {
            aeracaoData: [],
            pagination: { current_page: 1, last_page: 1, total: 0, links: [] },
            perPageOptions: [10, 25, 50, 100],
            periodoOptions: PERIODO_OPTIONS,
            PERIODO_MANUAL,
            per_page: 10,
            dataInicio: today,
            dataFinal: today,
            data_pre_definida: PERIODO_MANUAL,
            selectedSilo: null,
            selectedSiloNome: null,
            loadingDados: false,
            toast: useToast(),
            produtos: {
              1: "Vazio", 2: "Cevada", 3: "Feijão", 4: "Milho", 5: "Arroz",
              6: "Sorgo", 7: "Soja", 8: "Trigo", 9: "Canola", 10: "Azevém",
              11: "Linhaça", 12: "Painço", 13: "Alpiste", 14: "Milheto",
              15: "Aveia", 16: "Girassol", 17: "Outro",
            }
        };
    },
    computed: {
        ...mapState({
            silos: state => state.silos.silos,
            unidade: state => state.unidade.unidade || {},
            theme: state => state.ui.theme
        }),
        silosFiltered() {
          if (!this.unidade?.id) return this.silos || [];
          return (this.silos || []).filter(s => String(s.unidade_id) === String(this.unidade.id));
        },
        filteredPaginationLinks() {
            return this.pagination.links.filter(l => !isNaN(l.label) || l.label === '...');
        }
    },
    watch: {
        data_pre_definida() {
            this.aplicarPeriodo();
        },
        selectedSilo(val) {
          if (val) {
            const silo = this.silos.find(s => s.id === val);
            this.selectedSiloNome = silo ? silo.nome : null;
          }
        },
        per_page() {
            if(this.aeracaoData && this.aeracaoData.length > 0) this.gerarRelatorio(1);
        }
    },
    methods: {
        // Período pré-definido: recalcula as datas (também ao gerar, para "Hoje" etc. não ficarem velhos).
        aplicarPeriodo() {
            const datas = getDatasPeriodo(this.data_pre_definida);
            if (datas) {
                this.dataInicio = datas.dataInicio;
                this.dataFinal = datas.dataFinal;
            }
        },
        getProdutoNome(codigo) { return this.produtos[codigo] || "N/A"; },
        dataParte(dataHora) { return String(dataHora || '').split(' ')[0]; },
        horaParte(dataHora) { return String(dataHora || '').split(' ')[1] || ''; },
        async gerarRelatorio(page = 1) {
            this.aplicarPeriodo();
            if (!this.selectedSilo) return this.toast.error("Selecione um silo.");
            
            this.loadingDados = true;
            
            // 1. Limpamos os dados atuais para o card encolher e o loading ficar visível no topo
            this.aeracaoData = []; 

            try {
                const response = await this.$store.dispatch("silo/fetchAeracaoDataRelatorio", {
                    siloId: this.selectedSilo, 
                    dataInicio: this.dataInicio, 
                    dataFim: this.dataFinal,
                    page, 
                    per_page: this.per_page
                });

                if (response && response.data) {
                    this.aeracaoData = response.data;
                    this.pagination = { 
                        current_page: response.current_page || 1, 
                        last_page: response.last_page || 1, 
                        total: response.total || 0, 
                        links: response.links || [] 
                    };

                    // 2. UX: Se for uma troca de página, sobe o scroll para o topo do relatório
                    if (page > 1 || this.pagination.current_page > 1) {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                }
            } catch (error) {
                this.toast.error("Erro ao carregar dados.");
            } finally {
                // Pequeno delay para manter a estabilidade visual
                setTimeout(() => { this.loadingDados = false; }, 300);
            }
        },
        handlePaginationClick(link) {
            if (!link.url || link.active || link.label === '...') return;
            const url = new URL(link.url);
            this.gerarRelatorio(url.searchParams.get('page'));
        },
        limparFiltros() {
            this.data_pre_definida = PERIODO_MANUAL;
            this.selectedSilo = null;
            this.aeracaoData = [];
            this.pagination.total = 0;
        }
    },
};
</script>

<style scoped>
.tw-custom-input { @apply tw-w-full tw-border-none tw-rounded-xl tw-h-11 tw-p-3 tw-text-sm tw-outline-none; }
[data-theme="dark"] .tw-custom-input { background-color: rgba(39, 43, 47, 0.35); color: #f3f4f6; }
[data-theme="light"] .tw-custom-input { background-color: #f3f4f6; color: #1f2937; }
.tw-custom-input:focus { @apply tw-ring-2 tw-ring-green-500/20; }
::-webkit-scrollbar { width: 4px; }
::-webkit-scrollbar-thumb { background: #33b35a; border-radius: 10px; }


</style>